import $ from 'jquery';
import { getHeight, getWidth } from '../utils/window';
import _ from 'lodash';

export default function stockistPage(map) {
    // if stockist page
    if($('.stockist').length) {

        const $scroller = $('html, body');
        const $body = $('.body');
        const $stockist = $('.stockist');
        const $stockistContainer = $('.stockist-container');
        const $inputField = $stockist.find('.stockist-searchbar_input');
        const $inputSubmitButton = $stockist.find('#stockist-search');
        const $locationButton = $stockist.find('#stockist-location');
        const $backResults = $('.stockist-results_title');
        const geocoder = new google.maps.Geocoder();
        const style = {
            default: [
                {
                    elementType: 'geometry',
                    stylers: [
                    {
                        color: '#282726'
                    }
                    ]
                },
                {
                    elementType: 'labels',
                    stylers: [
                    {
                        visibility: 'off'
                    }
                    ]
                },
                {
                    featureType: 'administrative',
                    elementType: 'labels',
                    stylers: [
                    {
                        visibility: 'off'
                    }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry',
                    stylers: [
                    {
                        color: '#191818'
                    }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry.stroke',
                    stylers: [
                    {
                        visibility: 'off',
                    }
                    ]
                },
                {
                    featureType: 'road.local',
                    stylers: [
                    {
                        visibility: 'off'
                    }
                    ]
                },
                {
                    featureType: 'water',
                    stylers: [
                    {
                        color: '#191818'
                    }
                    ]
                }
            ],
            new: [
                {
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#282726"
                    }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                    {
                        "visibility": "off"
                    }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#757575"
                    }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                    {
                        "color": "#212121"
                    }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#757575"
                    }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "stylers": [
                    {
                        "visibility": "off"
                    }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#757575"
                    }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#181818"
                    }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#616161"
                    }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                    {
                        "color": "#1b1b1b"
                    }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                    {
                        "color": "#191818"
                    }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#8a8a8a"
                    }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#191818"
                    }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#191818"
                    }
                    ]
                },
                {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#191818"
                    }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#616161"
                    }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#757575"
                    }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#191818"
                    }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#757575"
                    }
                    ]
                }
            ]
        };

        var markers = [];
        var activeMarkers = [];
        var labelIndex = 0;

        const labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZABCDEFGHIJKLMNOPQRSTUVWXYZABCDEFGHIJKLMNOPQRSTUVWXYZABCDEFGHIJKLMNOPQRSTUVWXYZABCDEFGHIJKLMNOPQRSTUVWXYZABCDEFGHIJKLMNOPQRSTUVWXYZ';

        const iconSettings = {
            path: `M5,0A5,5,0,0,0,0,5C0,9.76,5,16,5,16s5-6.23,5-11A5,5,0,0,0,5,0ZM5,7.75a2.7,2.7,0,1,1,2.7-2.7A2.7,2.7,0,0,1,5,7.75Z`,
            // anchor: new google.maps.Point(10, 20),
            scale: 2.5,
            fillColor: '#cf885b',
            fillOpacity: 2,
            strokeWeight: 0,
            labelOrigin: new google.maps.Point(5.1, 5.1),
        };

        const apiUrl = "https://maps.googleapis.com/maps/api/js?libraries=geometry,places";
        const apikey = "AIzaSyBDAlnbFgst-evtUNrQEqHiOTHp0FaTyQc";
        // const geoUrl = "https://maps.googleapis.com/maps/api/geocode/json&key="+apikey;

        function getMarkersWithinRadius() {
            const currentLatLng = map.getCenter();

            markers.forEach((el)=>{
                var markerPos = {
                    lat: el.latitude,
                    lng: el.longitude
                }

                let markerLatLng = new google.maps.LatLng(markerPos);

                let dis = google.maps.geometry.spherical.computeDistanceBetween(currentLatLng, markerLatLng);
                if(dis < 50000) {

                    // let label = new google.maps.MarkerLabel({
                    //     color: '#ffffff',
                    //     text: labels[labelIndex++ % labels.length]
                    // });

                    el.marker.setLabel({
                        color: '#ffffff',
                        fontSize: '10px',
                        text: labels[labelIndex++ % labels.length]
                    });

                    el.distance = dis;

                    activeMarkers.push(el);
                }

                // limit to only 10
                if(activeMarkers.length > 10) {
                    activeMarkers.sort(function(a, b) {
                        if(a.distance < b.distance) {
                            return -1;
                        }

                        if(a.distance > b.distance) {
                            return 1;
                        }

                        return 0;
                    });

                    activeMarkers = activeMarkers.slice(0, 10);
                }

            });
        }

        // Sets the map on all markers in the array.
        function setMapOnAll(m) {

            if(activeMarkers.length) {
                // for (var i = 0; i < markers.length; i++) {
                //     activeMarkers[i].marker.setMap(m);
                // }

                activeMarkers.forEach(el=>{
                    el.marker.setMap(m);
                });
            }
        }

        function deleteActiveMarkers() {
            activeMarkers = [];
        }

        // Removes the markers from the map, but keeps them in the array.
        function clearMarkers() {
            setMapOnAll(null);
            labelIndex = 0;
        }

        // Shows any markers currently in the array.
        function showMarkers() {
            getMarkersWithinRadius();

            setMapOnAll(map);
        }

        function setupResultsList() {
            let $resultSubtitle = $('.stockist-results_subtitle');
            let $resultContainer = $('.stockist-results-container');
            $resultSubtitle.html('');
            $resultContainer.html('');

            if(activeMarkers.length) {

                $resultSubtitle.html(`Showing ${activeMarkers.length} Results`);

                activeMarkers.forEach((el, index)=>{

                    let div = `<div class="stockist-result">
                    <div class="stockist-result-icon"><i aria-hidden="true" class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><path d="M10,2.009c-2.762,0-5,2.229-5,4.99c0,4.774,5,11,5,11s5-6.227,5-11C15,4.239,12.762,2.009,10,2.009z M10,9.76  c-1.492,0-2.7-1.209-2.7-2.7s1.208-2.7,2.7-2.7c1.49,0,2.699,1.209,2.699,2.7S11.49,9.76,10,9.76z"></path></svg></i><div class="stockist-result-listing">${labels[index]}</div></div>
                    <div class="stockist-result-main">
                        <div class="stockist-result_title">${el.title}</div>
                        <div class="stockist-result_address">${el.address}</div>
                    `;

                    if(el.link) {
                        div = div + `<div class="stockist-result_link"><a target="_blank" href="${el.link}">View Website &rarr;</a></div>`;
                    }

                    div = div + `</div></div>`;

                    $resultContainer.append(div);
                });
            } else {
                $resultSubtitle.html(`No Results Found.`);
            }
        }

        function setUpMarkers() {
            // for testing

            var url = '';
            // console.log(window.location.pathname.indexOf('/cuvee/public/' !== -1));
            if(window.location.pathname.indexOf('/cuvee/public/') !== -1) {
                url = window.location.origin + '/cuvee/public/stockist.json';
            } else {
                url = window.location.origin + '/stockist.json';
            }
            $.getJSON(url, function(d){
                // console.log(d);
                d.data.forEach(function(element) {
                    // let mark = {};

                    let latitude = element.lat ? element.lat : 0;
                    let longitude = element.lng ? element.lng : 0;
                    let mark = {};

                    mark.marker = new google.maps.Marker({
                        position: {
                            lat: latitude,
                            lng: longitude
                        },
                        icon: iconSettings,
                    });

                    mark.title = element.title;
                    mark.address = element.address.trim();
                    mark.link = element.link;

                    mark.latitude = latitude;
                    mark.longitude = longitude;

                    // console.log('mark: ', mark);

                    // console.log(mark);
                    markers.push(mark);
                    // geocoder.geocode( {'address': element.address.trim(), componentRestrictions: { country: 'AU'} }, function(results, status) {

                    //     if (status == google.maps.GeocoderStatus.OK) {
                    //         let latitude = results[0].geometry.location.lat();
                    //         let longitude = results[0].geometry.location.lng();
                    //         let mark = {};

                    //         mark.marker = new google.maps.Marker({
                    //             position: {
                    //                 lat: latitude,
                    //                 lng: longitude
                    //             },
                    //             icon: iconSettings,
                    //         });

                    //         mark.title = element.title;
                    //         mark.address = element.address.trim();
                    //         mark.link = element.link;

                    //         mark.latitude = latitude;
                    //         mark.longitude = longitude;

                    //         console.log('mark: ', mark);

                    //         // console.log(mark);
                    //         markers.push(mark);
                    //     } else {
                    //         console.warn('warning: ', status);
                    //     }
                    // });
                });
            });
        }

        function checkKeyDown(e) {
            const $this = $(this);

            const code = (e.keyCode || e.which);

            switch (code) {
                // allow
                case 37:
                case 39:
                case 8:
                case 46:
                case 91:
                case 17:
                    return;
                    break;

                // // disallow
                // case 38:
                // case 40:
                // case 69:
                //     return false;
                //     break;

                // on enter
                case 13:
                checkInputNotEmpty();
                    return;
                    break;
                default:
                    if($this.val().length + 1 > 4) {
                        return false;
                    } else {
                        return;
                    }
                    break;

            }
        }

        function changeMapStyle(style) {
            map.setOptions(style);
        }

        function changeContainers(con) {
            if(con == 'search') {
                // $stockistContainer.removeClass('is-result');
                $stockistContainer.addClass('is-closing-result');
                setTimeout(()=>{
                    $stockistContainer.removeClass('is-result');
                    $stockistContainer.removeClass('is-closing-result');
                    $stockistContainer.addClass('is-search');
                }, 400);
            } else {
                // $stockistContainer.removeClass('is-search');
                $stockistContainer.addClass('is-closing-search');
                setTimeout(()=>{
                    $stockistContainer.removeClass('is-search');
                    $stockistContainer.removeClass('is-closing-search');
                    $stockistContainer.addClass('is-result');
                }, 400);
            }
        }

        function showResults(z=10) {
            changeMapStyle({
                zoom: z,
                styles: style.new
            });

            $('.map').removeClass('is-initial');

            changeContainers('result');
        }

        function showInitial() {

            if(activeMarkers.length) {
                clearMarkers();
                deleteActiveMarkers();
            }

            changeMapStyle({
                zoom: 7,
                styles: style.default
            });

            $('.map').addClass('is-initial');

            changeContainers('search');
        }

        function offsetCenter(latlng, offsetx, offsety) {

            // latlng is the apparent centre-point
            // offsetx is the distance you want that point to move to the right, in pixels
            // offsety is the distance you want that point to move upwards, in pixels
            // offset can be negative
            // offsetx and offsety are both optional

            const myLatLng = new google.maps.LatLng(latlng);

            var scale = Math.pow(2, map.getZoom());

            var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(myLatLng);
            var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);

            var worldCoordinateNewCenter = new google.maps.Point(
                worldCoordinateCenter.x - pixelOffset.x,
                worldCoordinateCenter.y + pixelOffset.y
            );

            var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

            map.setCenter(newCenter);

        }

        function settingMap(pos, zoom=10) {
            showResults(zoom);
            offsetCenter(pos, (getWidth() > 1080 ? 100 : 0), (getWidth() > 1080 ? 0 : -100));
            showMarkers();
            setupResultsList();
        }

        function checkInputNotEmpty() {
            if($inputField.val() && $inputField.val().length == 4) {
                // showResults();
                getLocationFromInput($inputField.val());
                $inputField.blur();
            }
        }

        function getLocationFromInput(input) {
            // console.log(input+' Australia');
            geocoder.geocode( {'address': input, componentRestrictions: { country: 'AU'} }, function(results, status) {

                if (status == google.maps.GeocoderStatus.OK) {
                    var latitude = results[0].geometry.location.lat();
                    var longitude = results[0].geometry.location.lng();

                    var pos = {
                        lat: latitude,
                        lng: longitude
                    };

                    settingMap(pos);
                }
            });
        }

        function autoSuccess(position) {
            let pos = {};

            if("coords" in position) {
                pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
            } else {
                pos = {
                    lat: position.latitude,
                    lng: position.longitude
                };

            }

            // let pos = {
            //     lat: position.latitude,
            //     lng: position.longitude
            // };

            // console.log(pos);

            settingMap(pos);
        }

        function autoFail(e) {
            console.log(e);
            $('#stockist-location').attr('disabled', true);
            alert(`Error getting position. Try again later. ${e.reason}`);
        }

        function autoFailsafe(e) {
            console.log(e);
            // $('#stockist-location').attr('disabled', true);
            // alert(`Error getting position. Try again later. Error: ${e.code}, ${e.message}`);

            $.ajax('https://ipapi.co/json').then(autoSuccess,autoFail);
        }

        function getLocationAutomatic() {
            // Try HTML5 geolocation.
            if (navigator.geolocation) {
                // console.log('in!');
                navigator.geolocation.getCurrentPosition(autoSuccess, autoFailsafe, {
                    enableHighAccuracy: true,
                    timeout: 1000,
                });
            } else {
                // Browser doesn't support Geolocation
                // handleLocationError(false, infoWindow, map.getCenter());
                $('#stockist-location').attr('disabled', true);
                alert('Your browser doesn\'t support geolocation');
            }
        }

        setUpMarkers();
        // console.log(markers);

        $inputField.on('keydown', checkKeyDown);

        $inputSubmitButton.click(checkInputNotEmpty);
        $locationButton.click(_.debounce(getLocationAutomatic, 500));
        $backResults.click(showInitial);

    }

}



// WEBPACK FOOTER //
// ./source/scripts/pages/stockist.js